<form class="vgs-form">
  <div class="field" *ngIf="!!ReceiverCardNr">
    <label>{{ ReceiverCardNr.label | translate }}</label>
    <div id="{{ ReceiverCardNr.id }}" class="form-field"></div>
    <h6
      class="err-msg"
      *ngIf="
        CardNumberFormState?.isinvalid &&
        CardNumberFormState?.isempty &&
        CardNumberFormState?.isdirty
      "
    >
      {{ "P2P.RECEIVERBLOCK.ERR.REQ.CARDNR" | translate }}
    </h6>
    <h6
      class="err-msg"
      *ngIf="
        CardNumberFormState?.checkedbin !== null &&
        CardNumberFormState?.checkedbin === false &&
        CardNumberFormState?.hasbin
      "
    >
      {{ "P2P.RECEIVERBLOCK.ERR.CHECKEDBIN" | translate }}
    </h6>
    <h6
      class="err-msg"
      *ngIf="
        CardNumberFormState?.isnotvalidcardtype && !CardNumberFormState?.isempty
      "
    >
      {{ "P2P.RECEIVERBLOCK.ERR.INVALIDTYPE.CARDNR" | translate }}
    </h6>
    <h6
      class="err-msg"
      *ngIf="
        !CardNumberFormState?.isnotvalidcardtype &&
        CardNumberFormState?.isinvalid &&
        !CardNumberFormState?.isempty
      "
    >
      {{ "P2P.RECEIVERBLOCK.ERR.INVALID.CARDNR" | translate }}
    </h6>
  </div>
</form>
